<template>
    <el-select
        :allow-create="allowCreate"
        :default-first-option="allowCreate || defaultFirst"
        :clearable="clearable"
        :disabled="disabled"
        v-bind="mergedProps"
        v-on="listeners"
        :filterable="filterable"
        :collapse-tags="collapseTags"
        :class="isFocused ? `is-active ${classes}` : `${classes}`"
        :no-data-text="noDataText"
        :placeholder="placeholder"
        :loading="loading"
        :multiple="isMulti"
    >
        <slot name="options"></slot>
    </el-select>
</template>
<script>
// Create select
export default {
    data() {
        return {
            selected: null,
            isFocused: false
        };
    },
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        classes: {
            type: String,
            required: false
        },
        isMulti: {
            type: Boolean,
            required: false,
            default: false
        },
        defaultFirst: {
            type: Boolean,
            required: false,
            default: false
        },
        allowCreate: {
            type: Boolean,
            required: false,
            default: false
        },
        disableItem: {
            type: Boolean,
            required: false,
            default: false
        },
        clearable: {
            type: Boolean,
            required: false,
            default: true
        },
        isSelectBlack: {
            type: Boolean,
            required: false,
            default: false
        },
        valueItem: {
            type: String,
            required: false,
            default: 'id'
        },
        textItem: {
            type: String,
            required: false,
            default: 'name'
        },
        filterable: {
            type: Boolean,
            required: false,
            default: true
        },
        collapseTags: {
            type: Boolean,
            default() {
                return false;
            },
            required: false
        },
        noDataText: {
            type: String,
            required: false
        },
        value: {
            default: function () {
                return null;
            }
        },
        loading: {
            default: function () {
                return false;
            }
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                blur: this.onBlur,
                focus: this.onFocus
            };
        },
        mergedProps() {
            return {
                ...this.$attrs,
                ...this.$props
            };
        }
    },
    methods: {
        onBlur() {
            this.isFocused = false;
        },
        onFocus() {
            this.isFocused = true;
        }
    }
};
</script>
<style lang="scss">
.el-select {
    .el-input__icon {
        line-height: 38px;
    }
    input {
        border-radius: 4px !important;
    }
    .el-tag.el-tag--info {
        background-color: #1d2939;
        color: #ffffff;
    }
    .el-tag.el-tag--info .el-tag__close {
        color: #ffffff;
        background-color: #1d2939;
    }

    .el-input {
        &.is-disabled {
            input {
                color: #343a40;
                background-color: #eee;
            }
        }
    }
}
</style>
